/**
 * Renders a severity icon beneath each tick whose data point is alerted
 * @param {Array} alertedLevels - An array with an entry per tick, in order: the
 * alert level of that tick ('high' / 'low'), or a falsy value when the tick has
 * no alert. An alerted tick with an unknown level falls back to the flag icon.
 * @param {Object} alertedIcons - Image elements keyed by severity, { high, low }
 * @returns {Object}
 */

const PADDING_TOP = 5;

export function alertedTickX(alertedLevels, alertedIcons, alertIconSize) {
  return {
    // Using `afterDatasetsDraw` instead of `afterDraw`, as
    // the latter fires after the tooltips are rendered, resulting
    // in the alerted icon appear on top of the tooltip
    afterDatasetsDraw: (chart) => {
      var ctx = chart.ctx;
      var xAxis = chart.scales.x;
      var yAxis = chart.scales.y;

      xAxis.ticks.forEach((value, index) => {
        const level = alertedLevels[index];

        if (level) {
          var x = xAxis.getPixelForTick(index);
          var icon = level === 'high' ? alertedIcons.high : alertedIcons.low;

          ctx.drawImage(
            icon,
            x - alertIconSize / 2,
            yAxis.bottom + PADDING_TOP,
            alertIconSize,
            alertIconSize
          );
        }
      });
    },
  };
}
